import { render, staticRenderFns } from "./ConsumerItem.vue?vue&type=template&id=4e22e192&"
import script from "./ConsumerItem.vue?vue&type=script&lang=js&"
export * from "./ConsumerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports